module.exports = __webpack_public_path__ + "img/pos4_txt.ff4c88a4.png";